import { ILocalizationItem } from "@multiweb/types/contracts/localizations";
import { WorkerMessage, WorkerResponseItem, WorkerResponseMessage } from "./WorkerMessages";

export interface LocKeysMessage extends WorkerMessage {
    type: "locKeys";
    data: { locKeys: string[] };
}

export interface LangMessage extends WorkerMessage {
    type: "lang";
    data: { language: string };
}

export interface LocResponseMessage extends WorkerResponseMessage {
    type: "locKeys";
    items: LocResponseItem[];
}

export interface LocResponseItem extends WorkerResponseItem {
    data: readonly ILocalizationItem[];
}
